import { render, staticRenderFns } from "./feedback_widget.vue?vue&type=template&id=c9154758&scoped=true&"
import script from "./feedback_widget.vue?vue&type=script&lang=js&"
export * from "./feedback_widget.vue?vue&type=script&lang=js&"
import style0 from "./feedback_widget.vue?vue&type=style&index=0&id=c9154758&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9154758",
  null
  
)

export default component.exports